document.addEventListener('DOMContentLoaded', function() {
    const hoverImage = document.getElementById('hover-image');
    const productTitle = document.getElementById('product-title');
    const productSubtitle = document.getElementById('product-subtitle');
    const menuItems = document.querySelectorAll('.child-link, .grandchild-link');

    const excludedTitles = ["Baby Blade"];

    function handleMenuItemHover(event) {
        const menuItem = event.currentTarget;
        const newImageSrc = menuItem.getAttribute('data-hover-image');
        const newTitle = menuItem.getAttribute('data-title');
        const newSubtitle = menuItem.getAttribute('data-subtitle');

        if (excludedTitles.includes(newTitle)) {
            productTitle.textContent = null || '';
            productSubtitle.textContent = null || '';
            return;
        }

        if (newImageSrc) {
            hoverImage.src = newImageSrc;
        } else {
            hoverImage.src = hoverImage.getAttribute('data-default-hover-image');
        }
        productTitle.textContent = newTitle || '';
        productSubtitle.textContent = newSubtitle || '';
    }

    menuItems.forEach(function(menuItem) {
        menuItem.addEventListener('mouseover', handleMenuItemHover);
    });
});